import { render, staticRenderFns } from "./getImgUrl.vue?vue&type=template&id=2ef4247c&scoped=true&"
import script from "./getImgUrl.vue?vue&type=script&lang=js&"
export * from "./getImgUrl.vue?vue&type=script&lang=js&"
import style0 from "./getImgUrl.vue?vue&type=style&index=0&id=2ef4247c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef4247c",
  null
  
)

component.options.__file = "getImgUrl.vue"
export default component.exports